import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import PostAddIcon from "@mui/icons-material/PostAdd";
import RemoveIcon from "@mui/icons-material/Remove";
import { Box, IconButton, TextField, Tooltip } from "@mui/material";
import { useState } from "react";

interface EditTestDataFieldProps {
  fieldIndex: number;
  keyContent: string;
  value: Object;
  isInsideArray: boolean;
  isNullKeyExists: boolean;
  handleKeyChange: (newKey: string) => void;
  handleValueChange: (newValue: string) => void;
  handleOnRemove: (keyToRemove: string) => void;
  handleOnAddAttribute: (isParentArray: boolean, fieldIndex: number) => void;
  handleOnAddObject: (isParentArray: boolean, fieldIndex: number) => void;
}
const EditTestDataField = ({
  fieldIndex,
  keyContent,
  value,
  isInsideArray,
  isNullKeyExists,
  handleKeyChange,
  handleValueChange,
  handleOnRemove,
  handleOnAddAttribute,
  handleOnAddObject,
}: EditTestDataFieldProps) => {
  const [tempKey, setTempKey] = useState(keyContent);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        paddingLeft: "16px",
      }}
    >
      <Box
        sx={{ display: "flex", justifyContent: "space-between", gap: "2rem" }}
      >
        <TextField
          variant="standard"
          // value={tempKey}
          value={keyContent}
          size="small"
          sx={{ width: "15rem" }}
          // onBlur={() => {
          //   console.log("tempKey", tempKey);
          //   handleKeyChange(tempKey);
          // }}
          // onChange={(e) => {
          //   setTempKey(e.target.value);
          //   // handleKeyChange(e.target.value);
          // }}
          onChange={(e) => {
            handleKeyChange(e.target.value);
          }}
        />
        :
        <TextField
          variant="standard"
          value={value}
          size="small"
          sx={{ width: "25rem" }}
          onChange={(e) => handleValueChange(e.target.value)}
        />
      </Box>
      <Box sx={{ display: "flex", gap: "0.5rem", marginRight: "1rem" }}>
        <Tooltip
          placement="top-start"
          slotProps={{
            popper: {
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [-15, -10],
                  },
                },
              ],
            },
          }}
          title="Remove"
        >
          <span>
            <IconButton
              sx={{ padding: "4px", cursor: "pointer" }}
              onClick={() => handleOnRemove(keyContent)}
            >
              <RemoveIcon />
            </IconButton>
          </span>
        </Tooltip>
        <Tooltip
          placement="top-start"
          slotProps={{
            popper: {
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [-15, -10],
                  },
                },
              ],
            },
          }}
          title={isNullKeyExists ? "" : "Add Attribute"}
        >
          <span>
            <IconButton
              sx={{ padding: "4px", cursor: "pointer" }}
              onClick={() => handleOnAddAttribute(isInsideArray, fieldIndex)}
              disabled={isNullKeyExists}
            >
              <PlaylistAddIcon />
            </IconButton>
          </span>
        </Tooltip>
        <Tooltip
          placement="top-start"
          slotProps={{
            popper: {
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [-15, -10],
                  },
                },
              ],
            },
          }}
          title={isNullKeyExists ? "" : "Add Object"}
        >
          <span>
            <IconButton
              sx={{
                padding: "4px",
                cursor: "pointer",
              }}
              onClick={() => handleOnAddObject(isInsideArray, fieldIndex)}
              disabled={isNullKeyExists}
            >
              <PostAddIcon />
            </IconButton>
          </span>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default EditTestDataField;
